import { Card, FormattedMessageDiv, FormattedNumberDiv, Tooltip } from "@odmonorepo/core-components"
import { Stack, Badge } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"
import { codToCents } from "../OfferReview/codToCents"

export const TLDetails = ({offer, amountType}) => {
    const intl = useIntl();
    
    return (
        <Card className="bg-light-gray shadow-none" bodyClassName="p-md-5 px-md-6 p-4">
        <Stack gap={3}>
        <FormattedMessageDiv
          className="fw-bold text-start"
          id="offerPreview.details"
        />
        <Stack direction="horizontal" className="text-start">
          <FormattedMessage id={`offerPreview.loanAmount`} />
          <FormattedNumberDiv
          value={offer.pricedDetails.lineAmount}
          className="ms-auto"
          style="currency"
          currency="USD"
          />
        </Stack>
        <Stack direction="horizontal" className="text-start">
          <div>
          <FormattedMessage id="offerPreview.originationFee" />
          <Tooltip
            title={intl.formatMessage({
            id: 'originationFee.tooltip',
            })}
          />
          </div>
          {offer.pricedDetails.loanOriginationFee === 0 ? (
          <Badge className="ms-auto fw-500" bg="success">
            {intl.formatMessage({ id: 'offerPreview.waived' })}
          </Badge>
          ) : (
          <FormattedNumberDiv
            value={offer.pricedDetails.loanOriginationFee}
            className="ms-auto"
            style="currency"
            currency="USD"
          />
          )}
        </Stack>
        <Stack direction="horizontal" className="text-start align-items-end">
          <div>
          <FormattedMessage id={`reviewPage.${amountType}.label`} 
            values={{
            break: (
              <span className="d-inline d-md-none">
              <br />
              </span>
            ),
            }}
          />
          <Tooltip
            title={intl.formatMessage({
            id: `tooltip.disbursement.${amountType}`,
            })}
          />
          </div>
          <FormattedNumberDiv
          value={offer.presentableDisbursementAmt}
          className="ms-auto"
          style="currency"
          currency="USD"
          />
        </Stack>
        <Stack direction="horizontal" className="text-start align-items-end">
          <FormattedMessage id="offerPreview.cod" />
          <FormattedNumberDiv
          value={codToCents(offer.pricedDetails.trueCentsOnDollar)}
          className="ms-auto"
          suffix="&cent;"
          minimumFractionDigits={1}
          maximumFractionDigits={4}
          />
        </Stack>
        <Stack direction="horizontal" className="text-start">
          <div>
          <FormattedMessage id={`offerPreview.apr`} />
          <Tooltip
            title={intl.formatMessage({
            id: `offerPreview.apr.tooltip`,
            })}
          />
          </div>
          <FormattedNumberDiv
          value={offer.pricedDetails.trueAPR}
          suffix="%"
          maximumFractionDigits={4}
          className="ms-auto"
          />
        </Stack>
        </Stack>
      </Card>
    )
}